<div class="donut" [id]="name"></div>